import { useState } from 'react';
import axios from 'axios';

export const useUpdateGoals = (getAllUserGoals: () => void) => {
  const [loadingUpdateGoal, setLoadingUpdateGoal] = useState(false);

  const updateUserGoal = async (data) => {
    setLoadingUpdateGoal(true);
    try {
      await axios.patch(`api/goals`, {
        ...data,
      });
      getAllUserGoals();
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingUpdateGoal(false);
    }
  };

  const postUserGoal = async (data) => {
    setLoadingUpdateGoal(true);
    try {
      await axios.post('api/goals', {
        ...data,
      });
      getAllUserGoals();
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingUpdateGoal(false);
    }
  };

  return { loadingUpdateGoal, updateUserGoal, postUserGoal };
};
